module.exports = __webpack_public_path__ + "235574588289fda2028a31bd9b454c20.pdf";